<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Gépkocsik</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/data/cars/add')"
        icon="el-icon-plus"
        v-can="'administration.car.create'"
      >
        Új Gépkocsi
      </el-button>
    </div>
    <list />
    <template v-if="$route.meta.showAddCarDialog">
      <car-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateCarDialog">
      <car-dialog
        :carId="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
  import List from '../../components/data/cars/List';
  import CarDialog from '../../components/data/cars/Dialog';

  export default {
    components: {
      List,
      CarDialog,
    },
  };
</script>
